(function (){
    'use strict';

    angular
        .module('studyad', []);
})();